import { createContext } from 'react'

export const initialState = false

export const UpdateTweetContext = createContext(initialState)
